import React, { useEffect, useContext, useRef, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
import {AddCreditDialog} from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';
import { withTranslation } from 'react-i18next';
import {EnterRefundDetails} from '../helper/Dialogs';
import { trainingCost } from '../../constants/global'

import Loading from '../helper/Loading';
import axios from 'axios';



const CreditHistory = props => {
    const history = useHistory()   
    const params = useParams()
    const context = useContext(authContext)

    const [availableCredit, setAvailableCredit] = useState(null);
    const [name, setName] = useState(null);
    const [data, setData] = useState(null);

    const [addCredit, setAddCredit] = useState({open: false, amount: trainingCost, reason: 'Refund', transId: '', requestDate: '', transactionAmount: 0});
    const [refundDetails, setRefundDetails] = useState({ processedDate:'', voucherID:'', ID: '' })
    
    const submitting = useRef(false)
    const {t} = props;

    const tableCells = [
        { id: 'createDate', label: t('CreditHistory.Date'), centered: false },
        { id: 'actionText', label: t('CreditHistory.Action'), centered: false },
        { id: 'amount', label: t('CreditHistory.Amount'), centered: false },
        { id: 'notes', label: t('CreditHistory.Notes'), centered: false },
        { id: 'createdByUsername', label: t('CreditHistory.By'), centered: false },
        { id: 'voucherID', label: t('CreditHistory.VoucherID'), centered: false },
        { id: 'processedDate', label: t('CreditHistory.ProcessedDate'), centered: false }

    ];

    async function getData() {
        let credit = await axios.get('/api/credit/log/'+ params.id, {});

        credit.data.forEach(e => {
            e.actionsDisabled = {
                allowRefund: (e.action === 'R' )
               }
        });
        setData(credit.data);

        
            let employer = await axios.get('/api/credit/employer/'+ params.id, {});
            console.log('employer data credit', employer);
            setAvailableCredit(employer.data.credit)
            setName(employer.data.name);    

                
    }


    useEffect(() => {
       
        getData();
    // render only once
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const onRefundUpdate = async (id) => {
        const creditLog = data.find(e => e.ID === id)
        console.log(creditLog);
         if(creditLog.action === 'R'){
            setRefundDetails( prev => {return {...prev, ID: creditLog.ID, processedDate: creditLog.processedDate, voucherID:creditLog.voucherID  }})
            console.log(refundDetails);
            handleClickOpen();
        }  
    }

    const handleDateProcessed = (event) => {
        event.persist()
        setRefundDetails( prev => {return {...prev, processedDate: event.target.value}})
        console.log('date processed', refundDetails.processedDate);
    }

    const handleVoucherID = (event) => {
        event.persist()
        setRefundDetails( prev => {return {...prev, voucherID: event.target.value}})
        console.log('voucher id', refundDetails.voucherID);
    }

    const handleRefundClick = async (e) => {
        e.preventDefault()

        if (submitting.current)
            return;
        submitting.current = true;

        let token = context.accessToken;
        let data = {
            voucherID: refundDetails.voucherID,
            processedDate: refundDetails.processedDate

        }

        console.log(data);
        await axios('/api/credit/log/' + refundDetails.ID , {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
        // reloads user credit log
        handleClose()
        getData()
        submitting.current = false

    }

// opens add credit dialog
    const onAddCreditDialogOpen = () => {
        console.log("onAddCredit");
        setAddCredit({open: true,  amount: trainingCost, notes: 'Courtesy Credit from GI-BMP Office'})
        console.log(addCredit.open);
    }

    // closes dialog
    const onAddCreditDialogClose = () => {
        setAddCredit({open: false, amount: trainingCost, notes: 'Courtesy Credit from GI-BMP Office'})
    }

    // submits credit additions and reload
    const handleAddCredit = async (e) => {
        e.preventDefault()

        if (submitting.current)
            return;
        submitting.current = true;

        let byUserName = context.user.username;
        let token = context.accessToken;

        let data = {
            amount:parseInt(addCredit.amount),
            notes: addCredit.notes,
            byUsername: byUserName
        }

        console.log(data);
        await axios('/api/credit/add/employer/' + params.id, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
       // reloads user credit log
        getData()

        onAddCreditDialogClose()
        submitting.current = false;

    }

    // handles textfield update for notes
    const handleNotes = (event) => {
        event.persist()
        setAddCredit( prev => {return {...prev, notes: event.target.value}})
    }

    // handles textfield update for amount
    const handleAmount = (event) => {
        event.persist()
        setAddCredit( prev => {return {...prev, amount: event.target.value}})
    }
    const actionButtons = [
        { label: 'Update', action: onRefundUpdate, delete: false, view: "allowRefund" },
    ];
   

    return (
        <>
            <PageHeader title={name + " " + t('CreditHistory.CreditHistoryD') }
                cancel={history.goBack} 
                actionButtons={[{ label: "Free Credit", action: onAddCreditDialogOpen }]}
        
            />
            <p> {t('CreditHistory.Name') } {name}</p>
            <p> {t('CreditHistory.AvailableCredit') }  {availableCredit}</p>
            <AddCreditDialog
                open={addCredit.open}
                amount={addCredit.amount}
                notes={addCredit.notes}
                onAddCredit={handleAddCredit}
                onAmountChange={handleAmount}
                onNotesChange={handleNotes}
                onClose={onAddCreditDialogClose}
            />
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>{t('CreditHistory.NoCreditHistory') } </h1> :
                    <>
                        <EnterRefundDetails 
                        open={open}
                        processedDate={refundDetails.processedDate}
                        voucherID={refundDetails.voucherID}
                        onClose={handleClose}
                        onDateChange = {handleDateProcessed}
                        onVocherChange = {handleVoucherID}
                        onRefundClick = {handleRefundClick}
                        />
                        <SimpleTable
                            data={data}
                            cellKey={"ID"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={true}
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(CreditHistory);